import { useTranslation } from 'react-i18next';
import GlobeIcon from '@/assets/icons/in-app-browser-globe.svg?react';
import MenuDotsIcon from '@/assets/icons/in-app-menu-dots.svg?react';
import { Text } from '@/components/base';
import { CopyLinkField } from '@/components/InAppBrowserNotice/components/CopyLinkField';
import { ManualOpenStep } from '@/components/InAppBrowserNotice/components/ManualOpenStep';

interface ManualOpenStepsProps {
  link: string;
  isLinkCopied: boolean;
  onCopyLink: () => void;
}

// For hosts with no open-in-browser URL: point at the host's own menu, or the link to paste.
export const ManualOpenSteps = ({ link, isLinkCopied, onCopyLink }: ManualOpenStepsProps) => {
  const { t } = useTranslation('activitySession');

  return (
    <div className="flex w-full flex-col gap-3">
      <div className="flex flex-col gap-2">
        <ManualOpenStep step={1} label={t('in_app_browser_notice.step_menu')}>
          <MenuDotsIcon aria-hidden className="h-[22px] w-5" />
        </ManualOpenStep>
        <ManualOpenStep step={2} label={t('in_app_browser_notice.step_open_in_browser')}>
          <GlobeIcon aria-hidden className="size-[22px]" />
        </ManualOpenStep>
      </div>
      <div className="flex items-center gap-3">
        <span aria-hidden className="h-px flex-1 bg-revamp-gray-200" />
        <Text version="revamp-v1" variant="caption" className="font-semibold text-revamp-gray-500">
          {t('in_app_browser_notice.or')}
        </Text>
        <span aria-hidden className="h-px flex-1 bg-revamp-gray-200" />
      </div>
      <div className="flex flex-col gap-2">
        <Text version="revamp-v1" variant="body5" className="font-medium text-revamp-gray-900">
          {t('in_app_browser_notice.copy_link_hint')}
        </Text>
        <CopyLinkField link={link} isLinkCopied={isLinkCopied} onCopyLink={onCopyLink} />
      </div>
    </div>
  );
};
